import './Footer.css'
import Social from './Social'

function Footer() {
  const date = new Date()
  const year = date.getFullYear()
  return (
    <footer className='footer'>
      <a href='https://github.com/lonebots' className='footer__link'>
        {/* Made with ❤️ 
        <br /> */}
        {year} © Jishnu Suresh
      </a>
      <Social />
    </footer>
  )
}

export default Footer
